
import { mapGetters } from 'vuex'
import { header, image, seo } from '../../customWhiteLabel'

export default {
  name: 'HeaderHome',
  data() {
    return {
      drawer: false,
      cartDrawer: false,
      systemBar: false,
      cartRigth: false,
      header,
      image,
      seo,
    }
  },

  computed: {
    ...mapGetters('cart', ['totalCart']),
    isScreenMobile() {
      return this.$vuetify.breakpoint.smAndUp
    },
  },
  mounted() {
    this.setCartRightValue()
    window.addEventListener('resize', this.setCartRightValue)
    this.$isDev ? (this.systemBar = true) : (this.systemBar = false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setCartRightValue)
  },
  methods: {
    closeCartDrawer() {
      this.cartDrawer = false
    },
    setCartRightValue() {
      this.cartRigth = window.innerWidth >= 1024
    },
    closeSystemBar() {
      this.systemBar = false
    },
  },
}
